import {ADD_TO_CART_BUTTONV2, GIA_WRAPPER_ID, MOUNT_POINT} from "@/config";

export default function patchDomTree() {
    console.debug("[Diamond Configurator] Patching DOM tree");

    const productForm = document.querySelector(
        'product-form'
    ) as HTMLFormElement;

    const addToCartButton = document.querySelector(
        ADD_TO_CART_BUTTONV2
    ) as HTMLButtonElement | null;
    if (addToCartButton !== null && addToCartButton.parentElement !== null) {
        addToCartButton.parentElement.style.display = "none";
    } else {
        console.debug("[Diamond Configurator] Did not find add to cart button");
    }

    const stockLevelWrapper = document.querySelector(
        '[data-slot="avaiablity"]'
    ) as HTMLDivElement | null;
    if (stockLevelWrapper !== null) {
        stockLevelWrapper.style.display = "none";
    } else {
        console.debug(
            "[Diamond Configurator] Did not find stock level element"
        );
    }

    if (productForm !== null) {
        const appElement = document.createElement("div");
        appElement.id = MOUNT_POINT;

        productForm.appendChild(appElement);
    } else {
        console.debug(
            "[Diamond Configurator] Did not find product form element"
        );
    }
}
